import { ETransportationType } from 'detailsv2/structure';

export const FIELDS_BY_TYPE = {
  [ETransportationType.Transfer]: ['bookedBy', 'contactInfo', 'confirmationNumber', 'provider', 'vehicleType'],
  [ETransportationType.Other]: ['bookedBy', 'contactInfo', 'confirmationNumber', 'provider', 'vehicleType'],
  [ETransportationType.Train]: [
    'confirmationNumber',
    'trainType',
    'trainNumber',
    'coachNumber',
    'seats',
    'serviceClass',
  ],
  [ETransportationType.RentalCar]: ['confirmationNumber', 'vehicleNumber', 'rentalCompanyName', 'rentalCompanyAddress'],
};

export const COMMON_FIELDS = [
  'duration',
  'arrivalTime',
  'departureTime',
  'arrivalTo',
  'departureFrom',
  'isCollapsible',
  'displaySettings',
  'notes',
];
